import React from "react";

const ServiceSessionBased = () => {
  return (
    <>
      <svg
        width="120"
        height="129"
        viewBox="0 0 167 179"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_46888_98170)">
          <path
            d="M1 13C1 6.37258 6.37258 1 13 1H154C160.627 1 166 6.37258 166 13V166C166 172.627 160.627 178 154 178H13C6.37258 178 1 172.627 1 166V13Z"
            fill="#F8F8F8"
          />
          <path
            d="M31.5317 42.098C38.4679 42.098 44.0908 36.4796 44.0908 29.549C44.0908 22.6184 38.4679 17 31.5317 17C24.5955 17 18.9727 22.6184 18.9727 29.549C18.9727 36.4796 24.5955 42.098 31.5317 42.098Z"
            stroke="#BFC7D9"
            stroke-miterlimit="10"
          />
          <path
            d="M18.7578 55.9531H39.9783M18.7578 66.9876H52.9704M122.478 55.9531H133.738"
            stroke="#BFC7D9"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M29.1494 87.75H137.201C142.831 87.75 147.378 92.2936 147.378 97.919V145.086C147.378 150.711 142.831 155.255 137.201 155.255H29.1494C23.5195 155.255 18.9723 150.711 18.9723 145.086V98.1354C18.7557 92.2936 23.303 87.75 29.1494 87.75Z"
            fill="#E4E4E4"
          />
          <path
            d="M122.477 66.9922H147.378"
            stroke="#BFC7D9"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M125.074 24V33.5199H123.125V24H125.074ZM135.468 24V33.5199H133.735L129.621 27.6781V33.5199H127.672V24H129.405L133.519 29.8418V24H135.468ZM139.582 24L141.964 31.1399L144.345 24H146.511L143.263 33.5199H140.664L137.416 24H139.582Z"
            fill="#71778E"
          />
          <path
            d="M29.1515 86.75H137.203C142.833 86.75 147.38 91.2936 147.38 96.919V103.41H18.7578V96.919C18.7578 91.2936 23.3051 86.75 29.1515 86.75Z"
            fill="#E4E4E4"
          />
          <path
            d="M19.1888 103.761H147.161M19.1888 129.724H147.161M29.1494 87.75H137.201C142.831 87.75 147.378 92.2936 147.378 97.919V145.086C147.378 150.711 142.831 155.255 137.201 155.255H29.1494C23.5195 155.255 18.9723 150.711 18.9723 145.086V98.1354C18.7557 92.2936 23.303 87.75 29.1494 87.75Z"
            stroke="#BFC7D9"
            stroke-miterlimit="10"
          />
        </g>
        <rect
          x="0.5"
          y="0.5"
          width="166"
          height="178"
          rx="16.5"
          stroke="#BFC7D9"
        />
        <defs>
          <clipPath id="clip0_46888_98170">
            <rect x="1" y="1" width="165" height="177" rx="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default ServiceSessionBased;
